<script>
import CustomTransition from 'linna/components/CustomTransition'

export default {
  name: 'SlowChannelChange',

  components: {
    CustomTransition
  },

  props: [
    'mode',
    'appear'
  ]

}
</script>

<template>
  <custom-transition
    :mode="mode"
    :appear="appear"
    :duration="{
      enter: 10000,
      leave: 550
    }"
    name="slow-channel-change"
  ><slot /></custom-transition>
</template>

<style lang="scss">

// .transition-slow-channel-change-enter-active,
// .transition-slow-channel-change-leave-active {}

// Start state for enter
.transition-slow-channel-change-enter {
  animation-name: turn-on;
  animation-duration: 1500ms;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
}

// End state for exit
.transition-slow-channel-change-leave-to {
  animation-name: turn-off;
  animation-duration: 550ms;
  animation-timing-function: $ease-out-quint;
  animation-fill-mode: forwards;
}

</style>
